._section-layers-panel_1xw2w_1 {
  position: fixed;
  width: 288px;
  height: -webkit-fit-content;
  height: -moz-fit-content;
  height: fit-content; }

._all-layers-button_1xw2w_6 {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 12px 24px; }
